import React from "react";
import { Link } from "react-router-dom";

const NavBar = () => {
  return (
    <div className="flex gap-4 items-center ">
      <Link to="/login" style={{ textDecoration: "none" }}>
        <p className="hover:!text-[#27AE60] font-poppins cursor-pointer text-[14px] text-[rgba(27, 31, 38, 0.72)]">
          Back to Flicktest
        </p>
      </Link>
      <Link to="/register" style={{ textDecoration: "none" }}>
        {" "}
        <button
          className=" font-poppins h-[40px] py-[6px] px-3 cursor-pointer text-[14px] font-[600] text-white flex items-center justify-center !bg-[#316BFF] hover:!bg-[#1c5af7] gap-3"
          style={{ borderRadius: 8 }}
        >
          Sign Up{" "}
          <svg
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 8.99999H12M12 8.99999L9.25001 7M12 8.99999L9.25001 11"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.33423 5.25C6.34432 3.61873 6.4247 2.73529 7.06501 2.15901C7.79727 1.5 8.97577 1.5 11.3328 1.5H12.1661C14.5231 1.5 15.7017 1.5 16.4339 2.15901C17.1661 2.81802 17.1661 3.87868 17.1661 6V12C17.1661 14.1213 17.1661 15.1819 16.4339 15.841C15.7935 16.4173 14.8119 16.4897 12.9993 16.4987M6.33423 12.75C6.34432 14.3812 6.4247 15.2647 7.06501 15.841C7.59944 16.3219 8.37152 16.4519 9.66594 16.487"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </Link>
    </div>
  );
};

export default NavBar;
